import { useBadgingTranslation } from '../../../../ui/hooks';
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
export const NoAccountForBulkActionDialogContent = ({ bulkActionTitle, onClose }) => {
    const { t } = useBadgingTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('badges.badgeDetails.accountBadgeTable.noEligibleBulkActionModal.title', { bulkActionTitle })),
        React.createElement(DialogContent, null,
            React.createElement(Typography, null, t('badges.badgeDetails.accountBadgeTable.noEligibleBulkActionModal.noEligibleDescription'))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => onClose() }, t('common.cancel')))));
};
